import { Helmet } from "react-helmet-async";
import { useSiteConfig } from "../hooks/useSiteConfig";

export function AccesibilidadPage() {
  const site = useSiteConfig();
  return (
    <>
      <Helmet>
        <title>Accesibilidad — Campus EMJC</title>
        <meta
          name="description"
          content="Declaración de accesibilidad de Campus EMJC conforme al Real Decreto 1112/2018."
        />
      </Helmet>
      <section className="container-emjc py-16">
        <p className="text-sm font-semibold uppercase tracking-widest text-brand-orange-deep">
          Accesibilidad
        </p>
        <h1 className="mt-2 max-w-3xl font-display text-4xl font-semibold leading-tight md:text-5xl">
          Declaración de accesibilidad
        </h1>

        <div className="prose-emjc mt-10 max-w-3xl space-y-6 text-lg leading-relaxed text-gray-700">
          <p>
            La <strong>Universidad de Extremadura</strong> se ha comprometido a hacer accesible este
            sitio web de conformidad con el{" "}
            <a
              className="text-brand-orange-deep hover:underline"
              href="https://www.boe.es/eli/es/rd/2018/09/07/1112"
              target="_blank"
              rel="noreferrer"
            >
              Real Decreto 1112/2018, de 7 de septiembre
            </a>
            , sobre accesibilidad de los sitios web y aplicaciones para dispositivos móviles del
            sector público.
          </p>

          <p>
            La presente declaración de accesibilidad se aplica al sitio web{" "}
            <code className="rounded bg-white px-1 py-0.5 ring-1 ring-gray-300">
              https://campusemjc.unex.es/
            </code>
            , excluyendo los contenidos enlazados de otros dominios externos.
          </p>

          <h2 className="font-display text-2xl font-semibold text-brand-ink">
            Situación de cumplimiento
          </h2>
          <p>
            Este sitio web es <strong>parcialmente conforme</strong> con el RD 1112/2018 y las{" "}
            <abbr title="Web Content Accessibility Guidelines">WCAG 2.1 nivel AA</abbr> debido a la
            falta de conformidad con los aspectos que se indican a continuación.
          </p>

          <h2 className="font-display text-2xl font-semibold text-brand-ink">
            Contenido no accesible
          </h2>
          <p>
            El contenido que se recoge a continuación no es accesible por los siguientes motivos:
          </p>
          <ul className="list-disc space-y-2 pl-6">
            <li>
              Algunas imágenes históricas migradas desde el sitio anterior pueden carecer de texto
              alternativo. Estamos completando la revisión.
            </li>
            <li>
              Algunos documentos PDF antiguos pueden no haber sido remediados conforme a PDF/UA.
            </li>
            <li>
              Vídeos incrustados desde plataformas externas pueden no contar con subtítulos en
              español.
            </li>
          </ul>

          <h2 className="font-display text-2xl font-semibold text-brand-ink">
            Preparación de la presente declaración
          </h2>
          <p>
            La presente declaración fue preparada el <time>26 de abril de 2026</time>. El método
            empleado para preparar la declaración ha sido una <strong>autoevaluación</strong>{" "}
            llevada a cabo por el propio organismo, complementada con auditoría automatizada
            mediante <code>axe-core</code> y revisión manual con lector de pantalla.
          </p>
          <p>Última revisión de la declaración: <time>27 de abril de 2026</time>.</p>

          <h2 className="font-display text-2xl font-semibold text-brand-ink">
            Observaciones y datos de contacto
          </h2>
          <p>
            Puede realizar comunicaciones sobre requisitos de accesibilidad (artículo 10.2.a) del RD
            1112/2018 a través del correo electrónico{" "}
            <a
              className="text-brand-orange-deep hover:underline"
              href={`mailto:${site.email}`}
            >
              {site.email}
            </a>
            . Por ejemplo:
          </p>
          <ul className="list-disc space-y-2 pl-6">
            <li>Informar sobre cualquier posible incumplimiento por parte de este sitio web.</li>
            <li>Transmitir otras dificultades de acceso al contenido.</li>
            <li>Formular cualquier otra consulta o sugerencia de mejora relativa a la accesibilidad.</li>
          </ul>

          <h2 className="font-display text-2xl font-semibold text-brand-ink">
            Procedimiento de aplicación
          </h2>
          <p>
            Si una vez realizada una solicitud de información accesible o queja, ésta hubiera sido
            desestimada, no se estuviera de acuerdo con la decisión adoptada, o la respuesta no
            cumpliera los requisitos contemplados en el artículo 12.5 del RD 1112/2018, la persona
            interesada podrá iniciar una <strong>reclamación</strong> ante la Universidad de
            Extremadura.
          </p>
        </div>
      </section>
    </>
  );
}
